module.exports = __webpack_public_path__ + "img/hohlschnitt_brillantgelb_farbnr119.337bde5f.jpg";